import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import Header from "../Header";
import Sidebar from "../SideBar";
import Content from '../Content';
import './Dashboard.css'; // Create this CSS file

export default function Dashboard() {
  // Sample data for charts
  const meetingsPerMonthData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Meetings per Month',
        data: [12, 19, 15, 8, 10, 22, 18, 14, 16, 11, 13, 20],
        backgroundColor: 'rgba(67, 97, 238, 0.6)',
        borderColor: 'rgba(67, 97, 238, 1)',
        borderWidth: 1,
        borderRadius: 6,
      },
    ],
  };

  const meetingStatusData = {
    labels: ['Completed', 'Cancelled', 'Rescheduled'],
    datasets: [
      {
        data: [85, 10, 5],
        backgroundColor: [
          'rgba(67, 97, 238, 0.7)',
          'rgba(247, 37, 133, 0.7)',
          'rgba(255, 193, 7, 0.7)',
        ],
        borderColor: [
          'rgba(67, 97, 238, 1)',
          'rgba(247, 37, 133, 1)',
          'rgba(255, 193, 7, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="app">
      {/* Sidebar */}
      <div className="sidebar-wrapper">
        <Sidebar />
      </div>

      <div className="main-content">
        {/* Header */}
        <div className="d-none d-md-block">
          <Header />
        </div>

        <Content>
          {/* Stats Cards */}
          <div className="row g-4 p-3 p-md-4">
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm h-100 stat-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-muted mb-3">Total Meetings</h6>
                      <h3 className="fw-bold">0</h3>
                      <small className="text-success">↑ 0% from last year</small>
                    </div>
                    <div className="stat-icon bg-primary bg-opacity-10 p-3 rounded">
                      <i className="bi bi-calendar-check text-primary fs-4"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm h-100 stat-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-muted mb-3">Completed</h6>
                      <h3 className="fw-bold">0</h3>
                      <small className="text-success">0% success rate</small>
                    </div>
                    <div className="stat-icon bg-success bg-opacity-10 p-3 rounded">
                      <i className="bi bi-check-circle text-success fs-4"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm h-100 stat-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-muted mb-3">Cancelled</h6>
                      <h3 className="fw-bold">0</h3>
                      <small className="text-danger">0% cancellation rate</small>
                    </div>
                    <div className="stat-icon bg-danger bg-opacity-10 p-3 rounded">
                      <i className="bi bi-x-circle text-danger fs-4"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Charts Section */}
          <div className="row px-3 px-md-4 mt-2">
            {/* Meetings per Month Chart */}
            <div className="col-12 col-lg-8 mb-4 mb-lg-0">
              <div className="card border-0 shadow-sm h-100 chart-card">
                <div className="card-header bg-white border-0">
                  <h5 className="mb-0 fw-bold">Meetings per Month</h5>
                </div>
                <div className="card-body">
                  <Bar 
                    data={meetingsPerMonthData}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          position: 'top',
                        },
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          grid: {
                            display: true,
                            drawBorder: false,
                            color: 'rgba(0, 0, 0, 0.05)'
                          }
                        },
                        x: {
                          grid: {
                            display: false
                          }
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Meeting Status Pie Chart */}
            <div className="col-12 col-lg-4">
              <div className="card border-0 shadow-sm h-100 chart-card">
                <div className="card-header bg-white border-0">
                  <h5 className="mb-0 fw-bold">Meeting Status</h5>
                </div>
                <div className="card-body d-flex align-items-center justify-content-center">
                  <div style={{width: '100%', maxWidth: '300px'}}>
                    <Pie 
                      data={meetingStatusData}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            position: 'bottom',
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Meetings Table */}
          <div className="row px-3 px-md-4 mt-4 mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm table-card">
                <div className="card-header bg-white border-0">
                  <h5 className="mb-0 fw-bold">Recent Meetings</h5>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Meeting</th>
                          <th>Date</th>
                          <th>Duration</th>
                          <th>Participants</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Quarterly Review</td>
                          <td>Jun 15, 2023</td>
                          <td>90 min</td>
                          <td>12</td>
                          <td><span className="badge bg-success">Completed</span></td>
                        </tr>
                        <tr>
                          <td>Product Launch</td>
                          <td>Jun 16, 2023</td>
                          <td>60 min</td>
                          <td>8</td>
                          <td><span className="badge bg-success">Completed</span></td>
                        </tr>
                        <tr>
                          <td>Team Sync</td>
                          <td>Jun 14, 2023</td>
                          <td>30 min</td>
                          <td>5</td>
                          <td><span className="badge bg-success">Completed</span></td>
                        </tr>
                        <tr>
                          <td>Budget Planning</td>
                          <td>Jun 10, 2023</td>
                          <td>120 min</td>
                          <td>6</td>
                          <td><span className="badge bg-danger">Cancelled</span></td>
                        </tr>
                        <tr>
                          <td>Client Demo</td>
                          <td>Jun 8, 2023</td>
                          <td>45 min</td>
                          <td>4</td>
                          <td><span className="badge bg-warning">Rescheduled</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Content>
      </div>
    </div>
  )
}